<template>
  <section>
    <div  class="phone-box">
      <div class="phone-list">VIP热线 <a href="tel:02195105966"  @click="countNumber(4,4)">95105966</a></div>
      <div class="phone-list" @click="countNumber(4,5)">普通热线 <a href="tel:02195105222">95105222</a></div>
      <p>7*24小时全年无休</p>
      <p>未开通95地区或海外用户请拨打：</p>
      <p>+86-21-50504728</p>
    </div>
     <router-link :to="{path: '/hotMap'}" class="check-map" @click.native="countNumber(4,6)">查看热线地图</router-link>
  </section>
  

</template>

<script>

export default {
  components: {
  },
  name: 'phone',
  created: function () {
    
  },
  data () {
    return {
     
    }
  },
  methods:{
    
  }
}
</script>


<style scoped>


.phone-box{width: 6.67rem;height: 5.11rem;margin-left: 0.44rem}
.phone-box img{width: 100%;height: 100%}
.check-map{color: #0000ff;width: 100%;display: block;position: absolute;text-align: center;height: 0.3rem;font-size: 0.3rem;bottom: 1.8rem;left: 0}
.phone-list{width: 6.68rem;height: 1.18rem;border: 1px solid #e5004f;border-radius: 5px;font-size: 0.3rem;line-height: 1.18rem;text-align: center;background: url(../../assets/phone-icon.png) no-repeat 0.34rem center; background-size: 0.55rem 0.55rem;display: block;margin-top: 0.5rem}
p{font-size: 0.28rem;text-align: center;line-height: 0.66rem;}
p:nth-of-type(1){margin-top: 0.54rem}
</style>



// WEBPACK FOOTER //
// src/components/base/phone.vue